import React from 'react'
import { BiSolidLike } from 'react-icons/bi'
import { RiBankFill } from 'react-icons/ri'

export const ClinicDashBoard2 = () => {
    return (
        <div className='w-full min-h-[80vh] rounded-lg bg-gradient-to-b from-blue-600 from-20% to-blue-200  to-80% flex flex-col justify-center items-center gap-5'>
            <div className=''>
                <h1 className='text-7xl font-bold'>12,360</h1>
                <h3 className='text-blue-900 font-semibold italic'>Total Bookings this week</h3>
            </div>
            <div className='flex flex-col h-full gap-10 w-fit justify-start'>
                <div className='flex justify-around items-center w-full bg-white rounded-xl p-10'>
                    <div className='w-fit flex flex-col items-center'>
                        <BiSolidLike className='text-4xl text-blue-900' />
                        <p className='text-2xl font-semibold'>370</p>
                        <p className='text-blue-500 italic'>Issues Solved</p>
                    </div>
                </div>
                <div className='flex justify-around items-center w-full bg-white rounded-xl p-10'>
                    <div className='w-fit flex flex-col items-center'>
                        <RiBankFill className='text-4xl text-blue-900' />
                        <p className='text-2xl font-semibold'>370</p>
                        <p className='text-blue-400 italic'>Total Clinics</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
